// utils/getAuthorLink.js

import { collection, getDocs } from "firebase/firestore";
import { db } from "../../firebase";

export const findAuthorByName = async (name) => {
  try {
    if (!name) return null;

    const surname = name.split(" ")[0].toLowerCase();
    const authorsSnapshot = await getDocs(collection(db, "author"));

    for (const doc of authorsSnapshot.docs) {
      const authorData = doc.data();
      const authorSurname = authorData.name?.split(" ")[0]?.toLowerCase();
      if (authorSurname === surname) {
        return { ...authorData, uid: doc.id };
      }
    }

    return null;
  } catch (err) {
    console.error("Помилка пошуку автора:", err);
    return null;
  }
};
